import React from "react";
import LegalPage from "@/components/LegalPage";

export default function Cancellation() {
  return (
    <LegalPage
      title="Cancellation Policy"
      eyebrow="CANCELLATIONS"
      lastUpdated="January 2026"
    >
      <p>
        This Cancellation Policy explains how to cancel a subscription, a
        booked psychic medium reading or a pending physical deck order with{" "}
        <strong>Tapped In Clarity</strong>.
      </p>

      <h2>1. Albetheine Oracle App Subscription</h2>
      <ul>
        <li>
          The app subscription renews every 3 months at £9.99 until cancelled.
        </li>
        <li>
          You may cancel at any time from within your account or by emailing{" "}
          <a href="mailto:tappedinclarity@gmail.com">tappedinclarity@gmail.com</a>.
        </li>
        <li>
          Cancelling stops future renewals. You will retain access to the app
          until the end of the period you have already paid for.
        </li>
        <li>
          As stated in our <a href="/refund">Refund Policy</a>, the current
          paid period is non-refundable once access has been provided.
        </li>
      </ul>

      <h2>2. Online Guidebook & Bundle Purchases</h2>
      <p>
        These are one-time digital purchases. There is no recurring billing
        and therefore nothing to cancel after purchase. By completing the
        purchase you waive your statutory 14-day cancellation right for
        digital content under the Consumer Contracts Regulations 2013.
      </p>

      <h2>3. Psychic Medium Readings (£150 / 60 minutes)</h2>
      <h3>Rescheduling by you</h3>
      <ul>
        <li>
          You may reschedule a reading <strong>free of charge</strong> if you give
          us at least <strong>48 hours' notice</strong> before the booked time.
        </li>
        <li>
          Rescheduling less than 48 hours before the session is at our
          discretion and may incur a £30 admin fee.
        </li>
        <li>
          No-shows and cancellations within 12 hours of the session are
          non-refundable.
        </li>
      </ul>

      <h3>Cancellation by you</h3>
      <ul>
        <li>
          Cancellation more than 7 days before the session — full refund.
        </li>
        <li>
          Cancellation 48 hours to 7 days before the session — 50% refund or
          full credit toward a future session.
        </li>
        <li>
          Cancellation less than 48 hours before the session — non-refundable.
        </li>
      </ul>

      <h3>Cancellation by us</h3>
      <p>
        If we have to cancel a reading we will offer a suitable alternative
        time or a full refund — whichever you prefer.
      </p>

      <h2>4. Physical Oracle Decks (Coming Soon)</h2>
      <ul>
        <li>
          Because decks are printed on demand, an order can only be cancelled{" "}
          <strong>before printing begins</strong>. This is usually within{" "}
          <strong>2 hours</strong> of placing your order.
        </li>
        <li>
          After printing has started, the order cannot be cancelled. The
          return rules in our <a href="/refund">Refund Policy</a> apply
          instead.
        </li>
        <li>
          To request a cancellation, email{" "}
          <a href="mailto:tappedinclarity@gmail.com">
            tappedinclarity@gmail.com
          </a>{" "}
          immediately after placing the order with your order number.
        </li>
      </ul>

      <h2>5. How to Cancel</h2>
      <p>
        For all cancellations, please email{" "}
        <a href="mailto:tappedinclarity@gmail.com">tappedinclarity@gmail.com</a>{" "}
        from the email address on your account, including:
      </p>
      <ul>
        <li>Your full name.</li>
        <li>The product or session you are cancelling.</li>
        <li>Your order number or booking reference.</li>
      </ul>
      <p>
        We will confirm cancellation within 3 working days.
      </p>
    </LegalPage>
  );
}
